<form #itemDetailsForm="ngForm" class="form-v2">
    <div class="modal-header">
        <h4 class="modal-title">{{ item.Description }}</h4>
        <p class="padding-left-30 padding-right-30">{{ parent.Description }}</p>
    </div>
    <div class="modal-body">
        <div class="row">
            <div class="col-xs-12">
                <div class="form-group">
                    <label class="text-info">Description</label>
                    <div class="full-width input-group">
                        <input
                            legacy-css
                            type="text"
                            class="form-control"
                            name="itemDescription"
                            [(ngModel)]="item.Description"
                            [disabled]="item.IsReadOnly || !!item.variation"
                            appSelectAllOnFocus
                            appSelectAllOnFocusFilter="New Actual Item"
                            appNullReplace="Item Description" />
                        <span class="input-group-btn" *ngIf="item.ItemType">
                            <button
                                type="button"
                                class="btn"
                                [ngClass]="{ 'btn-light-purple': item.ItemType === 1, 'btn-dark-beige': item.ItemType === 2 }">
                                {{ getItemCodeLabel(item.ItemTypeCode) }}
                            </button>
                        </span>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-xs-6">
                <div class="form-group" *ngIf="permissionService.isAvailable('jobs.maintain-job-costings.view-estimated')">
                    <label class="text-info">Est Qty</label>
                    <input
                        legacy-css
                        [disabled]="item.IsReadOnly || (item.Job.HasEstimate && item.Job.InvoiceMethod != 1)"
                        class="form-control text-right"
                        name="itemEstimatedQty"
                        [(ngModel)]="item.EstimatedQty"
                        type="text"
                        appNumeric
                        appSelectAllOnFocus
                        [decimals]="3"
                        [imperial]="item.IsImperial"
                        appNullReplace="0" />
                </div>
                <div class="form-group" *ngIf="permissionService.isAvailable('jobs.maintain-job-costings.view-estimated')">
                    <label class="text-info">UOM</label>
                    <input
                        legacy-css
                        class="form-control"
                        name="itemUOM"
                        [(ngModel)]="item.UOM"
                        [disabled]="item.IsReadOnly || (item.Job.HasEstimate && item.Job.InvoiceMethod != 1)"
                        type="text"
                        maxlength="50"
                        [typeahead]="unitMeasures"
                        [typeaheadMinLength]="0"
                        container="body" />
                </div>
                <div class="form-group" *ngIf="permissionService.isAvailable('jobs.maintain-job-costings.view-estimated')">
                    <label class="text-info">Est. Unit</label>
                    <input
                        legacy-css
                        class="form-control text-right"
                        name="itemEstimatedUnitCost"
                        [(ngModel)]="item.EstimatedUnitCost"
                        [disabled]="item.IsReadOnly || (item.Job.HasEstimate && item.Job.InvoiceMethod != 1)"
                        type="text"
                        appCurrency
                        appSelectAllOnFocus
                        required />
                </div>
                <div class="form-group" *ngIf="permissionService.isAvailable('jobs.maintain-job-costings.view-estimated')">
                    <label class="text-info">Est. Total</label>
                    <input
                        legacy-css
                        class="form-control text-right"
                        name="itemEstimatedCost"
                        disabled
                        [(ngModel)]="item.EstimatedCost"
                        appCurrency />
                </div>
            </div>
            <div class="col-xs-6">
                <div class="form-group">
                    <label class="text-info">Act. Qty</label>
                    <input
                        legacy-css
                        class="form-control text-right"
                        name="itemActualQty"
                        disabled
                        [(ngModel)]="item.ActualQty"
                        appNumeric
                        [decimals]="2"
                        [imperial]="item.IsImperial" />
                </div>
                <div class="form-group" style="margin-top: 159px">
                    <label class="text-info">Act. Total</label>
                    <input
                        legacy-css
                        class="form-control text-right"
                        name="itemActualCost"
                        [(ngModel)]="item.ActualCost"
                        [disabled]="item.hasOrders"
                        type="text"
                        appCurrency
                        appSelectAllOnFocus />
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-xs-6">
                <label class="text-info">Variance</label>
            </div>
            <div class="col-xs-6">
                <h4 class="text-right">
                    {{ item.VarianceCost | bxCurrency }}
                    <span
                        class="label margin-left-10"
                        [ngClass]="{ 'label-danger': item.VarianceCost < 0, 'label-success': item.VarianceCost >= 0 }"
                        *ngIf="item.VariancePercent !== 0"
                        >{{ item.VariancePercent }}%</span
                    >
                </h4>
            </div>
        </div>
        <div class="row">
            <div class="col-xs-12">
                <div class="form-group">
                    <label class="text-info">Notes</label>
                    <textarea
                        legacy-css
                        class="form-control"
                        name="itemNotes"
                        [(ngModel)]="item.Notes"
                        type="text"
                        placeholder="Enter Notes"></textarea>
                </div>
            </div>
        </div>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-default btn-o btn-wide" (click)="cancel()" type="button">Cancel</button>
        <button type="button" class="btn btn-primary btn-o btn-wide" (click)="ok()" type="button">Save and Close</button>
    </div>
</form>
